import ElementContentSignin from '@/components/sections/builder/elements/body/signin/content';
import ElementSettingSignin from '@/components/sections/builder/elements/body/signin/setting';
import { SigninElementDataType } from '@/components/sections/builder/elements/body/signin/type';
import { BetweenHorizontalStart } from 'lucide-react';

const defaultData: SigninElementDataType = {
  name: 'Signin',
  headingLabel: 'Sign in',
  buttonLabel: 'Sign in',
  topPadding: 30,
  bottomPadding: 30,
  roundedForm: 8,
};

export const ElementPreviewIcon = BetweenHorizontalStart;

const Signin = {
  type: 'signin',
  group: 'body_signin',
  defaultData,
  PreviewIcon: ElementPreviewIcon,
  Element: ElementContentSignin,
  Setting: ElementSettingSignin,
  isImmutable: true,
  maxEntries: 1,
};

export default Signin;
